import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import about from '../Assets/Images/about.png';
import aboutUs from '../Assets/Images/about-us.jpeg';
import policyImage from '../Assets/Images/slide6.jpeg';
import { Helmet } from 'react-helmet-async';

const About = () => {
  const [showFullText, setShowFullText] = useState(false);

  const toggleTextVisibility = () => {
    setShowFullText(!showFullText);
  };

  return (
    <div>
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content="Oyoyo Petroleum Resources Ltd., located in Oraifite, Anambra State, South-East Nigeria, is a leading manufacturer of high-quality lubricants for internal combustion and mechanical engines."
        />
        <link rel="canonical" href="https://oyoyolubricant.com/company/about" />
      </Helmet>     
      <div className="bg-accent1 py-2 text-sm text-slate-500 underline cursor-pointer">
        <Container>
          <p>Oyoyo Lubricants &rarr; About Us</p>
        </Container>
      </div>
      <div>
        <Container className="p-3 mb-8 px-4">
          <h1 className="text-4xl font-thin tracking-wider text-textColor-100 subpixel-antialiased mb-6">
            Oyoyo Lubricants
          </h1>
          <div className="relative h-48 md:h-72 w-full mb-8">
            <div
              className="h-full w-full rounded-lg shadow-lg"
              style={{
                backgroundImage: `url(${about})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-10 rounded-lg"></div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8  py-6">
            <div>
              <img
                src={aboutUs}
                alt="Lubricants and Machinery"
                className="w-full md:h-92 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div>
              <p className="text-base text-textColor-100 leading-relaxed mb-4">
                Oyoyo Petroleum Resources Ltd., located in Oraifite, Anambra State, South-East Nigeria, is a leading manufacturer of high-quality lubricants for internal combustion and mechanical engines. Since our inception in 2017, we have been committed to producing lubricating oils that meet the highest standards of quality and performance.
              </p>
              <p className="text-base text-textColor-100 leading-relaxed mb-4">
                We are fully approved by the Department of Petroleum Resources (DPR) and the Standards Organisation of Nigeria (SON) to produce lubricants with suitable API classifications. Our products are also certified under the Mandatory Conformity Assessment Programme (MANCAP), ensuring they conform to the relevant Nigerian Industrial Standards (NIS) before reaching the market or being exported.
              </p>
              <p className={`text-base text-textColor-100 leading-relaxed ${showFullText ? '' : 'line-clamp-4 overflow-hidden'}`}>
                At Oyoyo Petroleum Resources Ltd., we are dedicated to consistently meeting customer expectations and applicable legal requirements. Our product brands—My GOLD Super Tonic and ATF lubricants—are trusted by customers for their reliability and superior performance. In addition to our commitment to quality, we strive to create meaningful job opportunities within our community, contributing to economic growth and development.
              </p>
              <button
                onClick={toggleTextVisibility}
                className="mt-2 text-blue-500 hover:underline"
              >
                {showFullText ? 'Show Less' : 'Read More'}
              </button>
            </div>
          </div>
        </Container>
      </div>
      <div className="bg-gray-50 pb-8">
        <Container className="p-3 px-4">
          <h2 className="text-3xl font-thin tracking-wider text-textColor-100 subpixel-antialiased mb-6">
            Quality Policy Statement
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 py-4">
            <div>
              <img
                src={policyImage}
                alt="Quality Policy"
                className="w-full md:h-92 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className={`text-justify`}>
            <p className="text-base text-textColor-100 leading-relaxed mb-4">
                At Oyoyo Petroleum Resources Ltd., we are committed to leveraging modern technology and employing skilled, motivated personnel to produce and market high-quality lubricants that consistently meet customer expectations and comply with all applicable legal and regulatory requirements. Our operations are guided by the principles of the ISO 9001:2015 standard, ensuring that our products align with our strategic direction and support the continuous growth of our company.
              </p>
              <p className="text-base text-textColor-100 leading-relaxed mb-4">
                We are dedicated to the continuous improvement of our quality management system, ensuring that our policies are clearly communicated to and understood by all stakeholders and interested parties.
              </p>
              <p className="text-base text-textColor-100 leading-relaxed mb-4">
                To achieve our quality objectives, we implement the following strategies:
              </p>
              <ul className={`list-disc list-inside text-textColor-100 mb-4 ${showFullText ? '' : 'line-clamp-3 overflow-hidden'}`}>
                <li>Adherence to Industry Standards: Ensure all our products meet or exceed the required industry standards and certifications.</li>
                <li>Customer Focus: Consistently fulfill customer needs and expectations by providing reliable and high-performance lubricants.</li>
                <li>Employee Development: Invest in the continuous training and development of our workforce to maintain a highly skilled and motivated team.</li>
                <li>Technological Advancement: Utilize the latest technological advancements in our production processes to maintain product quality and efficiency.</li>
                <li>Continuous Improvement: Regularly review and improve our quality management practices to enhance overall performance.</li>
              </ul>
              <button
                onClick={toggleTextVisibility}
                className="mt-2 text-blue-500 hover:underline"
              >
                {showFullText ? 'Show Less' : 'Read More'}
              </button>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default About;
